/* eslint-disable id-length,complexity,max-statements */
import { hslToRgb } from '@material-ui/core';
var rgbToArray = function (rgbString) {
    var match = rgbString.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
    if (!match)
        return [];
    return [match[1], match[2], match[3]].map(function (item) { return parseInt(item); });
};
var hexToHSL = function (hex) {
    // Convert hex to RGB first
    var r = 0; // eslint-disable-line @typescript-eslint/no-explicit-any
    var g = 0; // eslint-disable-line @typescript-eslint/no-explicit-any
    var b = 0; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    }
    else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b);
    var cmax = Math.max(r, g, b);
    var delta = cmax - cmin;
    var h;
    var s;
    var l;
    if (delta === 0)
        h = 0;
    else if (cmax === r)
        h = ((g - b) / delta) % 6;
    else if (cmax === g)
        h = (b - r) / delta + 2;
    else
        h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0)
        h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return { h: h, s: s, l: l };
};
export var getMedianColor = function (color1, color2) {
    var rgb1 = rgbToArray(color1);
    var rgb2 = rgbToArray(color2);
    var rgb = rgb1.map(function (item, index) { return parseInt(((rgb1[index] + rgb2[index]) / 2).toFixed()).toString(16); });
    return '#' + rgb.join('');
};
export var calculatedGradient = function (hex) {
    var _a = hexToHSL(hex), h = _a.h, s = _a.s, l = _a.l;
    var HUE_YELLOW = 55;
    var FULL_CIRCLE = 360;
    var isCold = h > HUE_YELLOW && h < FULL_CIRCLE - HUE_YELLOW;
    var hueCorrection = 0;
    if (isCold) {
        var hueDistanceFromYellow = h - HUE_YELLOW;
        hueCorrection = -(((hueDistanceFromYellow + FULL_CIRCLE) / HUE_YELLOW) * 4);
    }
    else if (!isCold) {
        var hueDistanceFromYellow = HUE_YELLOW - h + (h >= FULL_CIRCLE - HUE_YELLOW ? FULL_CIRCLE : 0);
        hueCorrection = ((hueDistanceFromYellow + FULL_CIRCLE / 4) / HUE_YELLOW) * 4;
    }
    // correct hue: move hue to yellow
    var hue = h + hueCorrection;
    // correct saturation: if color is cold - reduce saturation
    var saturationCorrection = isCold ? (hue - HUE_YELLOW) / 2 : 0;
    var saturation = 100 - (s > 0 ? saturationCorrection : 100);
    // correct lightness +25 units (max 90 - because more is almost white - or initial color Lightness)
    var lightness = Math.min(l + 25, Math.max(l, 90));
    // convert back to rgb
    return hslToRgb("hsl(" + hue + ", " + saturation + ", " + lightness + ")");
};
//# sourceMappingURL=colors.js.map